import BackButton from 'components/BackButton';
import SaveButton from 'components/SaveButton';
import React from 'react';
import { Table } from 'react-bootstrap';

import DisplayImageType from 'components/DisplayImageType';
import { dateFormat } from 'helpers/Date';
import { numberToStringCurrency } from 'helpers/money';

const Resume = ({ backTab, saveForm, formData, tipoArquivoList }) => {
  return (
    <>
      <Table striped hover>
        <tbody>
          <tr>
            <td className="col-4">
              <b>Tipo de Ativação</b>
            </td>
            <td className="col-8">Digital</td>
          </tr>
          <tr>
            <td className="col-4">
              <b>Rede</b>
            </td>
            <td className="col-8">{formData.rede?.nome}</td>
          </tr>
          <tr>
            <td className="col-4">
              <b>Período da Ação</b>
            </td>
            <td className="col-8">
              {dateFormat(formData.inicio)} - {dateFormat(formData.fim)}{' '}
            </td>
          </tr>
          <tr>
            <td className="col-4">
              <b>Investimento Total (em 100% das lojas)</b>
            </td>
            <td className="col-8">
              {formData.investimento === -1
                ? 'Ativação contemplada no JBP'
                : numberToStringCurrency(formData.investimento)}
            </td>
          </tr>
          <tr>
            <td className="col-4">
              <b>Aprendizados e Pontos de Melhoria</b>
            </td>
            <td className="col-8">{formData.resultados}</td>
          </tr>
        </tbody>
      </Table>

      <div className="row">
        <h4 className="pt-4 pb-2">EVIDÊNCIAS:</h4>
        <DisplayImageType arquivos={formData.arquivos} tipoArquivoList={tipoArquivoList} />
      </div>

      <div className="d-flex justify-content-between pt-5">
        <BackButton backFunction={() => backTab()} />
        <SaveButton
          onClick={() => {
            saveForm();
          }}
        />
      </div>
    </>
  );
};

export default Resume;
